




import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class Trigger extends Vue {
	@Prop({ default: () => ({root: null,  threshold: '0'}), required: false }) private options;

	$refs!: {
		trigger;
	};

	private observer:any = null;

	mounted() {
		this.observer = new IntersectionObserver(entries => {
				this.handleIntersect(entries[0]);
		}, this.options);
		this.observer.observe(this.$refs.trigger);
	}

	destroyed() {
		this.observer.disconnect();
	}

	handleIntersect(entry) {
		if (entry.isIntersecting) {
			this.$emit('triggerIntersected')
		}
	}
}
